import log from 'loglevel';

/**
 * Custom logger object
 */
const logger = {
  error: log.error,
  log: log.log,
  info: log.info,
  warn: log.warn,
  setLevel: log.setLevel
};

export default logger;
